import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { marketplaceProfileGuard } from '../auth/marketplace-profile.guard';
import { AvailabilitiesListComponent } from './availabilities-list/availabilities-list.component';

export const AVAILABILITY_ROUTES: Routes = [
  {
    path: 'availabilities',
    component: AvailabilitiesListComponent,
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'availability/create',
    redirectTo: '/fleet/post-availability',
    pathMatch: 'full'
  },
  {
    path: 'availability-details',
    loadComponent: () => import('./availability-details/availability-details.component').then(m => m.AvailabilityDetailsComponent),
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'availability-details/:id',
    loadComponent: () => import('./availability-details/availability-details.component').then(m => m.AvailabilityDetailsComponent),
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'availability-details/:id/find-loads',
    loadComponent: () => import('./find-loads/find-loads.component').then(m => m.FindLoadsComponent),
    canActivate: [authGuard, marketplaceProfileGuard]
  }
];
